import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Tooltip, Button } from '@mui/material'
import Icon from '@mui/material/Icon'
import AddIcon from '@mui/icons-material/Add'
import { DataGrid } from '@mui/x-data-grid'
import { RootState } from '../../reducers'
import { getITAdminStateData } from '../../actions'
import { useStyles } from './SettingsStyles'
import EditStateCodeDialog from './EditStateCodeDialog'
import AddStateCodeDialog from './AddStateCodeDialog'
import DeleteStateDialog from './DeleteStateDialog'
import SuccessSnackBar from '../HOC/SuccesSnackBar'
import ErrorSnackBar from '../HOC/ErrorSnackBar'

function StatesTable({ userId, tableColumns }) {
  const classes = useStyles()
  const [addOpen, setAddOpen] = useState(false)
  const [editOpen, setEditOpen] = useState(false)
  const [paramsInfo, setParamsInfo] = useState({})
  const [infoPassed, setInfoPassed] = useState(false)
  const [deleteStateCodeOpen, setDeleteStateCodeOpen] = useState(false)
  const [addStateCode, setAddStateCode] = useState(false)
  const [editStateCode, setEditStateCode] = useState(false)
  const dispatch = useDispatch()

  const SettingsData = useSelector((state: RootState) => state.getITAdminStateData)
  const { delete_state_success, delete_state_error } = useSelector((state: RootState) => state.deleteStateResponse)
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)

  useEffect(() => {
    dispatch(getITAdminStateData())
  }, [])

  const displayAssignedData = SettingsData.data
  const AssignedIconRender = {
    field: '',
    headerName: 'Actions',
    disableColumnMenu: true,
    width: 300,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    renderCell: (params) => {
      return (
        <div>
          <Tooltip title="Edit State" placement="left-end">
            <Icon onClick={() => handleEditStateCodeOpen(params.row)}>edit_outlined</Icon>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Delete State" placement="left-end">
            <Icon onClick={() => handleDeleteStateCodeOpen(params.row)}>delete_outlined</Icon>
          </Tooltip>
        </div>
      )
    },
  }

  tableColumns.push(AssignedIconRender)

  const handleAddStateCodeOpen = () => {
    setAddStateCode(true)
    setAddOpen(true)
    setInfoPassed(true)
  }
  const handleEditStateCodeOpen = (params) => {
    setParamsInfo(params)
    setEditOpen(true)
    setEditStateCode(true)
    setInfoPassed(true)
  }

  const handleDeleteStateCodeClose = () => setDeleteStateCodeOpen(false)

  const openSnackBar = () => {
    setOpenSuccessSnackBar(true)

    setTimeout(() => setOpenSuccessSnackBar(false), 4000)
  }

  const handleDeleteStateCodeOpen = (params) => {
    setDeleteStateCodeOpen(true)
    setParamsInfo(params)
  }

  const handleAddClose = () => setAddOpen(false)
  const handleEditClose = () => setEditOpen(false)

  const SuccessMessage = `State deleted successfully`
  const ErrorMessage = `Delete State operation failed`

  return (
    <div className={classes.container}>
      {infoPassed && addStateCode && <AddStateCodeDialog open={addOpen} handleClose={handleAddClose} />}
      {infoPassed && editStateCode && (
        <EditStateCodeDialog open={editOpen} handleClose={handleEditClose} params={paramsInfo} />
      )}

      {delete_state_success && openSuccessSnackBar && <SuccessSnackBar message={SuccessMessage} />}
      {delete_state_error && openSuccessSnackBar && <ErrorSnackBar message={ErrorMessage} />}

      <div className={classes.mt}>
        <Box
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#0d688d73',
              fontWeight: '600',
            },
            '& .MuiDataGrid-columnHeader--moving': {
              backgroundColor: 'transparent !important',
            },
          }}
        >
          <Button
            className={classes.addProcedureCodeBtn}
            onClick={() => handleAddStateCodeOpen()}
            startIcon={<AddIcon />}
          >
            Add State
          </Button>

          <DataGrid
            disableColumnSelector
            autoHeight
            pagination
            pageSize={10}
            rowsPerPageOptions={[10]}
            rows={displayAssignedData}
            columns={tableColumns}
            loading={SettingsData?.fetchInProgress}
          />
          {deleteStateCodeOpen && (
            <DeleteStateDialog
              user={null}
              params={paramsInfo}
              openSnackBar={openSnackBar}
              open={deleteStateCodeOpen}
              onClose={handleDeleteStateCodeClose}
              data={SettingsData}
            />
          )}
        </Box>
      </div>
    </div>
  )
}

export default StatesTable
